// 混合一些页面跳来跳去的方法，因为有些跳转是要去套页面地方的，所以在此判断
import qs from 'qs';
import Bridge from '@public/lib/Bridge';
import APIS from '@/util/apis';
import {getPlatform} from '@/util/tool';
const platform = getPlatform();
const isAPP = platform.isYixinliApp || platform.isCeShiApp;

// 本来想用偏函数写的，但是发现baseURL也带有内部的参数，直接传是不行的，想办法能在内部转成变量吗？
function jumpFactory({baseUrl, baseUrlParam, yesOption}) {
  return function({channelId, scaleId, token, category, userId = '', unionId = '', openId = '', userKey = ''}, options) {
    console.log('跳转参数', arguments);
    let _baseUrl = `${location.protocol}${baseUrl}${arguments[0][baseUrlParam]}?isCp=1`; // 附加isCp=1 是告知壹心理APP，让其注入参数
    console.log('--- 跳转链接 --- _baseUrl', _baseUrl)
    if (platform.isCeShiApp) {
      // 口袋心理APP是走app打开URL，但是口袋心理APP不会注入登录信息，所以这边自己注入，壹心理APP的则是不用
      _baseUrl = `${_baseUrl}&channelId=${channelId}&userKey=${userKey}`;
    }
    if (yesOption) {
      console.log('app 打开URL')
      let myBridge = new Bridge();
      myBridge.call('openWebView', {url: `${_baseUrl}`, isCurrentPageOpen: 0});
    } else {
      let url = `${location.protocol}${baseUrl}${arguments[0][baseUrlParam]}`
      if (channelId == 4925 || channelId == 5292) {
        console.log('支付宝、美团小程序 打开URL')
        url += `?channelId=${channelId}&token=${token}`
        if (window.$uniAppNavto) {
          window.$uniAppNavto.push({
            path: '/pages/webView/webView?src=' + encodeURIComponent(url)
          })
        } else {
          location.href = url
        }
      } else if (channelId == 6677) {
        console.log('指定渠道 打开URL')
        url += `?channelId=${channelId}`
        location.href = url
      } else {
        console.log('web 打开URL')
        location.href = url
      }
      // location.href = `${location.protocol}${baseUrl}${arguments[0][baseUrlParam]}`;
    }
  }
}
export default {
  methods: {
    openVueRoute(route) {
      let url;
      if (this.$router) {
        // 是否存在vue-router
        let fullRoute = this.$router.matcher.match(route);
        url = `${location.origin}${location.pathname}#${fullRoute.fullPath}`
      } else if (route.path) {
        url = `${location.origin}${location.pathname}#${route.path}?${qs.stringify(route.query)}`;
      } else {
        console.error('route 对象不合法');
        return;
      }
      if (isAPP) {
        console.log('app 打开URL')
        let myBridge = new Bridge();
        myBridge.call('openWebView', {url: `${url}`, isCurrentPageOpen: 0});
      } else {
        console.log('web 打开URL')
        location.href = `${url}`;
      }
    },
    openUrl(url) {
      if (isAPP) {
        console.log('app 打开URL')
        let myBridge = new Bridge();
        let fullUrl = url;
        if (url.indexOf('http') === -1) {
          fullUrl = `http:${url}`;
        }
        myBridge.call('openWebView', {url: `${fullUrl}`, isCurrentPageOpen: 0});
      } else if (this.isAliMp) {
        // 只有 vue 才这样跳
        this.$uniAppNavto.push({
          path: '../webView/webView?src=' + encodeURIComponent(url)
        })
      } else {
        console.log('web 打开URL')
        location.href = `${url}`;
      }
    },
    goToProTestPage: jumpFactory({
      baseUrl: `//m${APIS.env}.xinli001.com/ceping/`,
      baseUrlParam: 'scaleId',
      yesOption: isAPP
    }),
    goToFunTestPage: jumpFactory({
      baseUrl: `//m${APIS.env}.xinli001.com/ceshi/`,
      baseUrlParam: 'scaleId',
      yesOption: isAPP
    }),
    goToSortPage: jumpFactory({
      baseUrl: `//m${APIS.env}.xinli001.com/ceshi/`,
      baseUrlParam: 'category',
      yesOption: isAPP
    })
  }
};



// WEBPACK FOOTER //
// ./src/mixins/pageJumper-mixin.js